
  <div class="container-fluid ">
    <div class="dashboard-container">
      <h2 class="text-center my-3  dashboard-title">Dashboard</h2>

    <div class="container p-5">

<!-- Team Selection  -->
  <div class="row mb-3">
     <div class="col-auto">
      <select class="form-select"
              [(ngModel)]="selectedTeam"
              (change)="onTeamOrAssignmentChange()">
        <option value="" disabled>Select a Team</option>
        <option *ngFor="let team of teams" [value]="team.teamId">
          {{ team.name }}
        </option>
      </select>
    </div>
  </div>

  <!-- Progress -->
  <div *ngIf="progressPercent > 0" class="mb-3">
    <h5 class="text-center">Team Progress: <span class="fw-bold">{{ progressPercent }}%</span></h5>
    <div class="progress" style="height: 25px;">
      <div class="progress-bar bg-success" role="progressbar" [style.width.%]="progressPercent">
        {{ progressPercent }}%
      </div>
    </div>
  </div>

 
  
  <div class="table-responsive" *ngIf="userTags && userTags.length > 0; else noData">

<table  class="table table-hover align-middle text-center border rounded-4">
    <thead class="table-light fs-5">
      <tr>
        <th class="border-end" (click)="sortData('username')">
          Username
         <span class="ms-1">
                  <i *ngIf="sortColumn==='username' && sortDirection==='asc'" class="bi bi-caret-up-fill text-primary"></i>
                  <i *ngIf="sortColumn==='username' && sortDirection==='desc'" class="bi bi-caret-down-fill text-primary"></i>
                  <i *ngIf="sortColumn!=='username'" class="bi bi-arrow-down-up text-muted"></i>
                </span>
        </th>
        <th class="border-end" (click)="sortData('status')">
          Status
           <span class="ms-1">
                  <i *ngIf="sortColumn==='status' && sortDirection==='asc'" class="bi bi-caret-up-fill text-primary"></i>
                  <i *ngIf="sortColumn==='status' && sortDirection==='desc'" class="bi bi-caret-down-fill text-primary"></i>
                  <i *ngIf="sortColumn!=='status'" class="bi bi-arrow-down-up text-muted"></i>
                </span>
        </th>
        <th class="border-end" (click)="sortData('assignedDate')">Assigned Date</th>
        <th class="border-end" (click)="sortData('completionDate')">Completion Date</th>
        <th class="border-end" (click)="sortData('targetCompletionDate')">
          Target Completion Date
          <span class="ms-1">
                  <i *ngIf="sortColumn==='targetCompletionDate' && sortDirection==='asc'" class="bi bi-caret-up-fill text-primary"></i>
                  <i *ngIf="sortColumn==='targetCompletionDate' && sortDirection==='desc'" class="bi bi-caret-down-fill text-primary"></i>
                  <i *ngIf="sortColumn!=='targetCompletionDate'" class="bi bi-arrow-down-up text-muted"></i>
                </span>
        </th>
        <th class="border-end" (click)="sortData('daysLeft')">
          No. of Days Left
          <span class="ms-1">
                  <i *ngIf="sortColumn==='noOfDaysLeft' && sortDirection==='asc'" class="bi bi-caret-up-fill text-primary"></i>
                  <i *ngIf="sortColumn==='noOfDaysLeft' && sortDirection==='desc'" class="bi bi-caret-down-fill text-primary"></i>
                  <i *ngIf="sortColumn!=='noOfDaysLeft'" class="bi bi-arrow-down-up text-muted"></i>
                </span>
        </th>
         <th class="border-end align-middle">Overdue</th>
        <th class="border-end">Send Reminder</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let userTag of userTags">
        <td  class="border-end ">{{ userTag.user.Name }}</td>
        <td  class="border-end">{{ userTag.status }}</td>
        <td class="border-end">{{ userTag.assignedDate | date:'mediumDate' }}</td>
        <td class="border-end">{{ userTag.completionDate ? (userTag.completionDate | date:'mediumDate') : '-' }}</td>
        <td class="border-end">{{ userTag.targetCompletionDate | date:'mediumDate' }}</td>
        <td class="border-end">{{ userTag.daysLeft }}</td>
        <td class="border-end">
          <span [ngClass]="{'text-danger fw-bold': userTag.overdue, 'text-success': !userTag.overdue}">
            {{ userTag.overdue ? 'Yes' : 'No' }}
          </span>

        </td>
        <td  class="border-end ">
          <button *ngIf="userTag.status !== 'completed' "class="btn btn-dark-blue" (click)="sendReminder(userTag)">Send</button>
        </td>
      </tr>
    </tbody>
</table>
</div>
<ng-template #noData>
  <div class="text-center p-5">
    <h5 class="text-muted">No users or assignments available for this team.</h5>
  </div>
</ng-template>
</div>
</div>
</div>


